import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProductModel } from '../../shared/model/product.model';
import { ProductService } from '../../shared/service/product.service';
import { MeasureTableService } from '../../shared/service/measure-table.service';
import { MessageComponent } from '../../shared/component/message/message.component';

@Component({
    selector: 'app-product-form',
    templateUrl: './product-form.component.html',
    styleUrls: ['./product-form.component.css']
})
export class ProductFormComponent implements OnInit {

    @ViewChild(MessageComponent) message: MessageComponent;

    product: ProductModel = new ProductModel();
    editMode: boolean = false;
    isLoading: boolean = false;

    measureTableOptions: any[] = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private productService: ProductService,
        private measureTableService: MeasureTableService
    ) { }

    ngOnInit() {
        this.loadMeasureTableOptions();
        const id = this.route.snapshot.paramMap.get('id');
        if (id && id !== 'new') {
            this.editMode = true;
            this.loadProduct(Number(id));
        }
    }

    loadMeasureTableOptions() {
        this.measureTableService.getPaginated(0, 1000000).subscribe(
            (result: any) => {
                const rows = result['rows'] || [];
                this.measureTableOptions = [
                    { label: '—', value: null },
                    ...rows.map((t: any) => ({
                        label: t.name,
                        value: t.id || t.measure_table_id
                    }))
                ];
            },
            () => {}
        );
    }

    loadProduct(id: number) {
        this.isLoading = true;
        this.productService.getById(id).subscribe(
            (result: any) => {
                this.product = Object.assign(new ProductModel(), result);
                if (!this.product.other_infos) {
                    this.product.other_infos = {};
                }
                this.isLoading = false;
            },
            () => {
                this.message.error();
                this.isLoading = false;
            }
        );
    }

    validate(): boolean {
        return ProductModel.validate(this.product);
    }

    onSave() {
        if (!this.validate()) {
            this.message.error('need_more_data');
            return;
        }
        this.productService.save(this.product).subscribe(
            () => {
                this.message.success('success_save_message');
                setTimeout(() => this.router.navigate(['/product']), 1500);
            },
            () => this.message.error()
        );
    }

    onCancel() {
        this.router.navigate(['/product']);
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/product/product-form/product-form.component.ts